export default __webpack_public_path__ + "images/react/images/cbretention-logo.png";